/**
 * API calls for the landing page (anonymous endpoints).
 *
 * Uses the shared axios instance from `@/lib/api`. Even though the
 * early-access endpoint is anonymous, the request still goes through
 * the same instance so error normalization stays consistent.
 */

import api from "@/lib/api";

export type EarlyAccessRole = "shipper" | "carrier" | "both";
export type EarlyAccessLocale = "no" | "en";

export type EarlyAccessPayload = {
  name: string;
  email: string;
  phone_number_e164: string;
  role: EarlyAccessRole;
  locale: EarlyAccessLocale;
  organization_number?: string;
  company_name?: string;
};

export type EarlyAccessReceipt = {
  ok: boolean;
  created_at: string;
};

export async function submitEarlyAccess(
  payload: EarlyAccessPayload,
): Promise<EarlyAccessReceipt> {
  const { data } = await api.post<EarlyAccessReceipt>("/early-access", payload);
  return data;
}

export type CompanyLookup = {
  organization_number: string;
  name: string;
  organization_form_code: string | null;
  organization_form_description: string | null;
  address: string | null;
  postal_code: string | null;
  postal_place: string | null;
  municipality: string | null;
  vat_registered: boolean;
  bankrupt: boolean;
  under_liquidation: boolean;
  under_forced_liquidation: boolean;
  deleted_date: string | null;
  industry_code: string | null;
  industry_description: string | null;
};

export async function lookupCompany(organizationNumber: string): Promise<CompanyLookup> {
  const { data } = await api.get<CompanyLookup>(
    `/early-access/company-lookup/${encodeURIComponent(organizationNumber)}`,
  );
  return data;
}
